import React from "react"
import ReactDOM from "react-dom"
import "assets/main.css"
import "assets/css/index.css"
import App from "./app"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
)
